export class AsociarDocumentoAEntidadRequest {
    public idDocumento: number = 0;
    public idTipoEntidad: number =0;
    public idEntidad: number=0;
}